import React from 'react';
import { Stack, Typography } from '@mui/material';

export const SettingsEntryList = ({ items, children }) => (
  <Stack gap={2} py={3} px={2}>
    {items.map(({ label, count, onClick }) => (
      <Typography
        key={label}
        variant="body2"
        fontWeight={700}
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(event) => event.key === 'Enter' && onClick()}
        color="primary"
        sx={{ cursor: 'pointer', width: 'fit-content' }}
      >
        {count === undefined ? label : `${label} (${count})`}
      </Typography>
    ))}
    {children}
  </Stack>
);
